import React from "react";

import { Typography } from "@material-ui/core";

import {
  ReferenceField,
  ReferenceInput,
  TextField,
  TextInput,
} from "react-admin";

import { AppType } from "../../../utils/constants";

export const TenantRender = ({ record, label, ...props }) => {
  return record?.tenantId === AppType.ADMIN ? (
    <Typography variant="body2">Admin</Typography>
  ) : (
    <ReferenceField
      {...props}
      label=""
      source="tenantId"
      reference="reloadYards"
      link={false}
      record={record}
    >
      <TextField source="name" />
    </ReferenceField>
  );
};

export const TenantInput = ({ record, ...props }) =>
  record?.appType === AppType.ADMIN ? (
    <TextInput
      label="Tenant"
      source="name"
      defaultValue="Admin"
      variant="outlined"
    />
  ) : (
    <ReferenceInput
      {...props}
      label="Tenant"
      source="tenantId"
      reference="reloadYards"
      link={false}
      record={record}
      disabled={true}
    >
      <TextInput label="Tenant" source="name" variant="outlined" />
    </ReferenceInput>
  );
